export class DatePickerProperties {
    public DateLabel: string;
    public InvalidDateError: string;
    public DateRangeError: string;
}
